import { ready } from '../global/instantiate';
import initLoadMore from '../sections/products/loadMore';
import lazyloadify from '../global/lazyload';

ready(() => {
  initLoadMore(() => {
    lazyloadify()
  })
});